<template>
  <NotificationText v-bind="$props">
    <template #primary>
      <i>{{peerName}}</i> möchte dir {{filesLength}} {{files}} senden
    </template>
    <template v-if="notification.data.description" #secondary>
      {{notification.data.description}}
    </template>
    <template #detail-content>
      <PeerFiles
        :files="notification.data.files"
        :description="notification.data.description"
      />
    </template>
    <template #actions>
      <v-btn text small color="red" @click="reject">Ablehnen</v-btn>
      <v-btn text small color="primary" @click="resolve">{{
        serviceWorkerSupported ? 'Herunterladen' : 'Übertragen'
      }}</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import PeerNotificationTextMixin from './peer-notification-text-mixin';
  import {serviceWorkerSupported} from '../../../assets/js/utils';


  export default {
    name: 'PeerFilesRequest',

    mixins: [
      PeerNotificationTextMixin
    ],

    data: () => ({
      serviceWorkerSupported
    }),

    methods: {
      reject() {
        PeerNotificationTextMixin.methods.reject.call(this, new Error('declined'));
      }
    }
  };
</script>
